import {t, use} from "i18next";
import React, { useEffect, useState } from "react"; 
import i18n from "../../../../i18n";
import PageHead from "../../../layout/PageHead";
import {
  CheckOutlined,
  ControlOutlined,
  ExportOutlined,
  KeyOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { ROUTES } from "../../../../config/consts/routes";
import {NOTIFICATION_TYPES, OPERATIONS, SECTIONS} from "../../../../config/constants";
import { useTranslation } from "react-i18next";
import "../publish/Publish.css";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Divider,
  Empty,
  Form,
  Input,
  List,
  Menu, MenuProps,
  Radio,
  RadioChangeEvent,
  Select,
  Tooltip,
} from "antd";
import FormItem from "antd/lib/form/FormItem";
import GroupCodesService from "../../../../services/groupcodes/GroupCodesService";
import TablesService from "../../../../services/tables/TablesService";
import EnvironmentService from "../../../../services/environments/EnvironmentService";
import { GetTablesRequest } from "../../../../models/tables/GetTablesRequest";
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
  ResponderProvided,
} from "react-beautiful-dnd";
import { GetFieldsRequest } from "../../../../models/fields/GetFieldsRequest";
import saveAs from "file-saver";
import {useForm} from "antd/es/form/Form";
import {ExportConfiguration} from "../../../../models/loadfile/ExportConfiguration";
import NotificationsUtil from "../../../shared/utils/NotificationsUtil";
import {useWatch} from "antd/lib/form/Form";

interface ExportConfigurationName {
  configurationName: string;
}

const routes = [
  {
    path: ROUTES.general.main.route,
    breadcrumbName: SECTIONS.general.name,
  },
  {
    breadcrumbName: SECTIONS.operation.name,
  },
  {
    path: ROUTES.operation.publish.route,
    breadcrumbName: ROUTES.operation.publish.name,
  },
];

const Publish = () => {
  const { t, i18n } = useTranslation("translations");
  const [selectedGroupCode, setSelectedGroupCode] = useState<any>();
  const [selectedEntity, setSelectedEntity] = useState<any>();
  const [groupCodes, setGroupCodes] = useState<any>([]);
  const [entities, setEntities] = useState<any>([]);
  const [environments, setEnvironments] = useState<any>([]);
  const [selectedEnvironment, setSelectedEnvironment] = useState<any>([]);
  const [tables, setTables] = useState<any>([]);
  const [selectedLoadfile, setSelectedLoadfile] = useState<any>([]);
  const [fields, setFields] = useState<any>([]);
  const [fieldTypes, setFieldTypes] = useState<any>([]);
  const [fixedFields, setFixedFields] = useState<any>([]);
  const [fixedFieldsRender, setFixedFieldsRender] = useState<any>([]);
  const [selectedField, setSelectedField] = useState<any>(null);
  const [draggableFields, setDraggableFields] = useState<any>([]);
  const [selectedExport, setSelectedExport] = useState("new");
  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  
  const [configurationName, setConfigurationName] = useState<any>();
  const [exportConfigs, setExportConfigs] = useState<any[]>([]);
  const [selectedConfig, setSelectedConfig] = useState<number | undefined>(undefined);
  const [exportConfigFields, setExportConfigFields] = useState<any[]>([]);
  
  const [exportConfigurationForm] = Form.useForm<ExportConfiguration>();
  const [exportConfigurationName] = Form.useForm<ExportConfigurationName>();
  
  const [isFieldsLoading, setIsFieldsLoading] = useState(false);
  
  const [isDelimiterVisible, setIsDelimiterVisible] = useState(false);
  const [isTextQualifierVisible, setIsTextQualifierVisible] = useState(false);
  const [isOtherExportFieldsVisible, setIsOtherExportFieldsVisible] = useState(false);

  const encodingOptions = [
    { label: "UTF-8", value: "utf-8" },
    { label: "UTF-16 LE", value: "utf-16le" },
    { label: "UTF-16 BE", value: "utf-16be" },
    { label: "UTF-32", value: "utf-32" },
    { label: "ASCII", value: "ascii" },
    { label: "ISO-8859-1 (Latin-1)", value: "iso-8859-1" },
    { label: "Windows-1252", value: "windows-1252" },
    { label: "Shift-JIS (Japanese)", value: "shift-jis" },
    { label: "GB2312 (Simplified Chinese)", value: "gb2312" },
    { label: "Big5 (Traditional Chinese)", value: "big5" },
  ];

  const dateFormatOptions = [
    { label: "YYYY-MM-DD", value: "YYYY-MM-DD" },
    { label: "DD/MM/YYYY", value: "DD/MM/YYYY" },
    { label: "MM/DD/YYYY", value: "MM/DD/YYYY" },
    { label: "YYYY/MM/DD", value: "YYYY/MM/DD" },
    { label: "DD-MM-YYYY", value: "DD-MM-YYYY" },
    { label: "MM-DD-YYYY", value: "MM-DD-YYYY" },
    { label: "DD MMM YYYY", value: "DD MMM YYYY" },
    { label: "MMMM DD, YYYY", value: "MMMM DD, YYYY" },
    { label: "YYYY.MM.DD", value: "YYYY.MM.DD" },
    { label: "DD.MM.YYYY", value: "DD.MM.YYYY" },
  ];

  const exportFormats = [
    { label: ".xlsx", value: ".xlsx" },
    { label: ".csv", value: ".csv" },
    { label: ".txt", value: ".txt" },
    { label: ".json", value: ".json" },
    { label: ".xml", value: ".xml" },
  ];

  const delimiterOptions = [
    { label: "Comma (,)", value: "," },
    { label: "Semicolon (;)", value: ";" },
    { label: "Tab (\\t)", value: "\t" },
    { label: "Pipe (|)", value: "|" },
    { label: "Colon (:)", value: ":" },
    { label: "Space ( )", value: " " },
    { label: "Custom", value: "custom" }, 
  ];

  const textQualifierOptions = [
    { label: 'Double Quote (")', value: '"' },
    { label: "Single Quote (')", value: "'" },
  ];

  useEffect(() => {
    GroupCodesService.getAll().then((response: any) => {
      const data = response.data;
      setGroupCodes(data);
    });
    TablesService.getAllEntities().then((response: any) => {
      const data = response.data;
      setEntities(data);
    });
    EnvironmentService.getAll().then((response: any) => {
      const data = response.data;
      setEnvironments(data);
    });
    TablesService.getFieldTypes().then((response: any) => {
      setFieldTypes(response.data);
    });
  }, []);

  const onSelectedEnvironmentChange = (value: string) => {
    setSelectedEnvironment({ ...selectedEnvironment, environment: value });
  };

  const onSelectedLoadfileChange = (value: string) => {
    setSelectedLoadfile({ ...selectedLoadfile, id: value });
    setSelectedLoadfile({ ...selectedLoadfile, id: value });
    setCheckedKeys([]);
    setSelectedExport("new");
    setSelectedConfig(undefined);
    setConfigurationName(undefined);
    exportConfigurationForm.resetFields();
    exportConfigurationName.resetFields();
  };

  useEffect(() => {
    if (selectedEntity && selectedGroupCode) {
      const model: GetTablesRequest = {
        entityId: selectedEntity,
        operationId: OPERATIONS.LOADFILE,
        groupCode: "",
      };

      TablesService.getTables(model).then((response: any) => {
        const data = response.data.sort((a: any, b: any) => {
          if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
          if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
          return 0;
        });
        setTables(data);
      });
      
      setFields([]);
      setSelectedLoadfile(null);
    }
  }, [selectedEntity, selectedGroupCode]);

  useEffect(() => {
    if (selectedLoadfile) {
      setIsFieldsLoading(true);
      const model: GetFieldsRequest = {
        tableId: selectedLoadfile?.id,
      };
      TablesService.getFields(model).then((response: any) => {
        const data = response.data;
        const dataFields = data.map((x: any) => ({
          ...x,
          isKey: x.isKey,
        }));
        setFields(
            dataFields
        );

        const nonSystemFields = dataFields.filter((item: any) => !item.isSystemField);
        const allKeys = nonSystemFields.map((item) => item.id.toString());
        setCheckedKeys(allKeys);

        setFields(dataFields);
        setIsFieldsLoading(false);
      });
      setCheckedKeys([]);
    }
  }, [selectedLoadfile]);


  useEffect(() => {
    if (selectedExport === "existing") {
      TablesService.getAllExportLoadfileConfiguration().then((res) => {
        setExportConfigs(res.data);
      });
    }
  }, [selectedExport, selectedConfig]);

  useEffect(() => {
    if (selectedConfig) {
      TablesService.getExportLoadfileConfigurationFields(selectedConfig).then((res) => {
        const filteredData = res.data.filter((x: any) => x.tableID === selectedLoadfile?.id);
        if (filteredData.length !== 0) {
          setCheckedKeys(filteredData.filter(x => x.shouldExport).map(x => x.fieldID.toString()));
          setFields(fields.map((x: any) => ({
            ...x,
            configurationFieldId: filteredData.find(y => y.fieldID === x.id)?.id,
            position: filteredData.find(y => y.fieldID === x.id)?.order || x.position,
          }))); 
        }
        
        const config = exportConfigs.find(x => x.configurationID === selectedConfig);
        
        exportConfigurationForm.setFieldsValue({
            delimiter: config.delimiter,
            textQualifier: config.textQualifier,
            exportFormat: config.fileFormat,
            includeHeader: config.includeHeader,
            encoding: config.encoding,
            dateFormat: config.dateFormat,
            fileName: config.fileName,
            configurationName: config.configurationName,
        })
        exportConfigurationName.setFieldsValue({
                configurationName: config.configurationName,
        })
        
      });
    }
  }, [selectedConfig]);

  const exportLoadfile = (saveConfiguration = false, exportFile = false) => {
    const model: any = {
      groupCode: selectedGroupCode,
      entity: entities.find((x: any) => x.id === selectedEntity)?.name,
      tableID: selectedLoadfile?.id,
      environment: selectedEnvironment?.environment,
      tableName: tables.find((x: any) => x.id == selectedLoadfile?.id)?.name,
      databaseName: tables.find((x: any) => x.id == selectedLoadfile?.id)?.database,
      schemaName: tables.find((x: any) => x.id == selectedLoadfile?.id)?.schema,
      fields: fields
          .filter((x: any) => !x.isSystemField)
          .map((x: any) => ({
            id: x.configurationFieldId,
            fieldID: x.id,
            name: x.name,
            order: x.position,
            shouldExport: checkedKeys.findIndex((y) => y == x.id) !== -1,
            tableID: x.tableId,
          })),
      fileFormat: exportConfigurationForm.getFieldValue("exportFormat"),
      delimiter: exportConfigurationForm.getFieldValue("delimiter"),
      textQualifier: exportConfigurationForm.getFieldValue("textQualifier"),
      encoding: exportConfigurationForm.getFieldValue("encoding"),
      dateFormat: exportConfigurationForm.getFieldValue("dateFormat"),
      includeHeader: exportConfigurationForm.getFieldValue("includeHeader"),
      saveConfiguration: saveConfiguration,
      export: exportFile,
      fileName: exportConfigurationForm.getFieldValue("fileName"),
      configurationName: exportConfigurationName.getFieldValue("configurationName"),
      configurationID: selectedConfig,
    };

    if (exportFile) {
      TablesService.exportLoadfile(model)
          .then((response: any) => {
            let url = window.URL.createObjectURL(new Blob([response.data]));
            saveAs(url, model.fileName + model.fileFormat);
            NotificationsUtil.openNotificationDialog({
              description: t("Page.Operation.Publish.Notifications.ExportSuccess", {
                lngs: i18n.languages,
                defaultValue: "Export successful!",
              }),
              type: NOTIFICATION_TYPES.SUCCESS,
              logError: false,
            });
          })
          .catch(() => {
            NotificationsUtil.openNotificationDialog({
              description: t("Page.Operation.Publish.Notifications.ExportFailed", {
                lngs: i18n.languages,
                defaultValue: "Export failed!",
              }),
              type: NOTIFICATION_TYPES.ERROR,
              logError: true,
            });
          });
    } else if (saveConfiguration && !model.configurationID) {
      TablesService.saveExportLoadfileConfiguration(model)
          .then(() => {
            NotificationsUtil.openNotificationDialog({
              description: t("Page.Operation.Publish.Notifications.SaveSuccess", {
                lngs: i18n.languages,
                defaultValue: "Configuration saved successfully!",
              }),
              type: NOTIFICATION_TYPES.SUCCESS,
              logError: false,
            });
          })
          .catch(() => {
            NotificationsUtil.openNotificationDialog({
              description: t("Page.Operation.Publish.Notifications.SaveFailed", {
                lngs: i18n.languages,
                defaultValue: "Save configuration failed!",
              }),
              type: NOTIFICATION_TYPES.ERROR,
              logError: true,
            });
          });
    } else if (saveConfiguration && model.configurationID) {
      TablesService.updateExportLoadfileConfiguration(model.configurationID, model)
          .then(() => {
            NotificationsUtil.openNotificationDialog({
              description: t("Page.Operation.Publish.Notifications.UpdateSuccess", {
                lngs: i18n.languages,
                defaultValue: "Configuration updated successfully!",
              }),
              type: NOTIFICATION_TYPES.SUCCESS,
              logError: false,
            });
          })
          .catch(() => {
            NotificationsUtil.openNotificationDialog({
              description: t("Page.Operation.Publish.Notifications.UpdateFailed", {
                lngs: i18n.languages,
                defaultValue: "Update configuration failed!",
              }),
              type: NOTIFICATION_TYPES.ERROR,
              logError: true,
            });
          });
    }
  };

  useEffect(() => {
    if (fields) {
      setDraggableFields(fields?.filter((item: any) => !item.isSystemField));
    }
  }, [fields]);

  useEffect(() => {
    let mappedFields = fixedFields
      .sort(function (a: any, b: any) {
        return a.position - b.position;
      })
      .map((item: any) => {
        return {
          key: item.id,
          label: item.name,
          typeId: item.typeId,
        };
      });

    setFixedFieldsRender(renderItems(mappedFields));
  }, [fixedFields, fieldTypes]);

  useEffect(() => {
    if (fields) {
      const nonSystemFields = fields.filter((item: any) => !item.isSystemField);
      setDraggableFields(nonSystemFields);
    }
  }, [fields]);

  const renderItems = (items: any) => {
    return items.map((item: any) =>
      getItem(
        <>
          {item?.label?.length > 25
            ? item?.label?.slice(0, 25) + "..."
            : item?.label}
        </>,
        item.key,
        null,
        null,
        null
      )
    );
  };

  const handleCheckboxChange = (key: string | number, checked: boolean) => {
    const strKey = key.toString();
    setCheckedKeys((prev) =>
      checked ? [...prev, strKey] : prev.filter((k) => k !== strKey)
    );
  };

  const handleSelectAllChange = (e) => {
    const allKeys = draggableFields.map((f) => f.id.toString());
    setCheckedKeys(e.target.checked ? allKeys : []);
  };

  const isAllSelected =
    draggableFields.length > 0 &&
    checkedKeys.length === draggableFields.length &&
    draggableFields.every((f) => checkedKeys.includes(f.id.toString()));

  type MenuItem = Required<MenuProps>["items"][number];

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }

  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;

    const clonedListItems = JSON.parse(JSON.stringify(draggableFields));
    const [reorderedItem] = clonedListItems.splice(result.source.index, 1);
    clonedListItems.splice(result.destination.index, 0, reorderedItem);

    const maxPosition =
      fixedFields.length > 0
        ? Math.max(...fixedFields.map((item: any) => item.position))
        : 0;

    clonedListItems.forEach((element: any, index: any) => {
      element.position = maxPosition + index + 1;
    });

    const finalListItems = [...fixedFields, ...clonedListItems];

    setFields(finalListItems);
  };

  const handleExportChange = (e) => {
    const value = e.target.value;
    setSelectedExport(value);
    if (value === "new") {
      setSelectedConfig(undefined);
      exportConfigurationForm.resetFields();
      exportConfigurationName.resetFields();
    } else if (value === "existing") {
      setSelectedConfig(undefined);
      exportConfigurationForm.resetFields();
      exportConfigurationName.resetFields();
    }
  };

  const exportFormat = Form.useWatch(
    "exportFormat",
    exportConfigurationForm
  );

  useEffect(() => {
    const format = exportConfigurationForm.getFieldValue("exportFormat");
    
    if (format !== ".csv" && format !== ".txt") {
      setIsDelimiterVisible(false);
      setIsTextQualifierVisible(false);
      exportConfigurationForm.setFieldsValue({ delimiter: undefined, textQualifier: undefined });
    }
    
    if (format === ".csv") {
      setIsDelimiterVisible(true);
      setIsTextQualifierVisible(true);
    }
    
    if (format === ".txt") {
      setIsDelimiterVisible(true);
      setIsTextQualifierVisible(false);
      exportConfigurationForm.setFieldsValue({ textQualifier: undefined });
    }
    
    if (format) {
      setIsOtherExportFieldsVisible(true);
    }
    else {
      setIsOtherExportFieldsVisible(false);
    }
  }, [exportFormat]);

  return (
    <div>
      <PageHead
        title={t("Page.Operation.Publish.Headers.Publish", {
          lngs: i18n.languages,
          defaultValue: "Publish",
        })}
        icon={<ExportOutlined />}
        routes={routes}
        groupCodes={groupCodes}
        entities={entities}
        operations={[]}
        selectedGroupCode={selectedGroupCode}
        selectedEntity={selectedEntity}
        selectedOperation={undefined}
        setSelectedGroupCode={setSelectedGroupCode}
        setSelectedEntity={setSelectedEntity}
        setSelectedOperation={undefined}
        setSelectGroupCodeDisabled={false}
        setSelectEntityDisabled={false}
        setSelectOperationDisabled={true}
        mainAction={[]}
        otherActions={[]}
        setActionsDisabled={true}
      />
      <div className="body-container">
        <div className="select-loadfile-container">
          <div className="title">
            <span>1. Select loadfile</span>
          </div>
          <Divider />
          <div className="selection-container">
            <Form<ExportConfigurationName>
                form={exportConfigurationName}
                layout="vertical"
                size="small"
            >
              <Form.Item
                label={t("Page.Operation.Publish.Labels.SelectEnvironment", {
                  lngs: i18n.languages,
                  defaultValue: "Select Environment:",
                })}
                tooltip={t("Page.Operation.Publish.Labels.SelectEnvironment", {
                  lngs: i18n.languages,
                  defaultValue: "",
                })}
              >
                <Select
                  placeholder={t(
                    "Page.Operation.Clustering.SelectEnvironment",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Use default environment",
                    }
                  )}
                  allowClear
                  showSearch={true}
                  showArrow={true}
                  options={[
                    ...environments.map((env: any) => ({
                      label: env.name,
                      value: env.name,
                    })),
                  ]}
                  value={selectedEnvironment?.environment} 
                  onChange={onSelectedEnvironmentChange}
                ></Select>
              </Form.Item>
              <Form.Item
                label={t("Page.Operation.Publish.Labels.SelectLoadfile", {
                  lngs: i18n.languages,
                  defaultValue: "Select Loadfile:",
                })}
                tooltip={t("Page.Operation.Publish.Labels.SelectLoadfile", {
                  lngs: i18n.languages,
                  defaultValue: "",
                })}
              >
                <Select
                  placeholder={t("Page.Operation.Clustering.SelectLoadfile", {
                    lngs: i18n.languages,
                    defaultValue: "Select Loadfile:",
                  })}
                  allowClear
                  showSearch={true}
                  showArrow={true}
                  options={[
                    ...tables.map((x: any) => ({
                      label: x.name,
                      value: x.id,
                    })),
                  ]}
                  value={selectedLoadfile?.id}
                  onChange={onSelectedLoadfileChange}
                ></Select>
              </Form.Item>
      {selectedLoadfile?.id && (
          <>
              <Form.Item label="Export Configuration">
                <Radio.Group
                  onChange={handleExportChange}
                  value={selectedExport}
                  className="radio-group"
                >
                  <Radio value="new">New Export Configuration</Radio>
                  <Radio value="existing">Existing Export Configuration</Radio>
                </Radio.Group>
              </Form.Item>
                {selectedExport === "new" && (
                    <Form.Item 
                    name="configurationName"
                    label={t("Page.Operation.Publish.Labels.ConfigurationName", {
                        lngs: i18n.languages,
                        defaultValue: "Configuration Name:",
                    })}
                    tooltip={t("Page.Operation.Publish.Labels.NameFile", {
                        lngs: i18n.languages,
                        defaultValue: "",
                    })}
                    >
                    <Input
                        disabled={false}
                        placeholder={
                        t("General.Placeholders.EnterValue", {
                            lngs: i18n.languages,
                            defaultValue: "Enter configuration name",
                        })!
                        }
                        value={configurationName}
                        onChange={(e) => setConfigurationName(e.target.value)}
                    />
                    </Form.Item>
                )}
              {selectedExport === "existing" && (
                  <Form.Item
                      label={t("Page.Operation.Publish.Labels.SelectConfiguration", {
                        lngs: i18n.languages,
                        defaultValue: "Select Configuration:",
                      })}
                      tooltip={t("Page.Operation.Publish.Labels.SelectConfiguration", {
                        lngs: i18n.languages,
                        defaultValue: "",
                      })}
                  >
                    <Select
                        placeholder="Select Existing Configuration"
                        allowClear
                        showSearch
                        showArrow
                        value={selectedConfig}
                        onChange={(value: number) => setSelectedConfig(value)}
                        options={exportConfigs.map((config) => ({
                          value: config.configurationID,
                          label: config.configurationName,
                        }))}
                    >
                    </Select>
                  </Form.Item>
              )}
                </>
            )}   
            </Form>
          </div>
        </div>
        {selectedLoadfile?.id && (
            <div className="select-fields-container">
              <div className="select-fields-title">
                <span>2. Select and/or reorder fields</span>
              </div>
              <>
                <Divider />
                <div className="fields-container">
                  <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId="DropId">
                      {(provided) => (
                          <div ref={provided.innerRef} {...provided.droppableProps}>
                            <Menu
                                items={fixedFieldsRender}
                                selectedKeys={[selectedField?.id?.toString()]}
                                style={{ marginRight: "5px" }}
                            />
                            <List.Item>
                              <Checkbox
                                  indeterminate={
                                      checkedKeys.length > 0 &&
                                      checkedKeys.length < draggableFields.length
                                  }
                                  onChange={handleSelectAllChange}
                                  checked={isAllSelected}
                              >
                                Select All
                              </Checkbox>
                            </List.Item>
                            {draggableFields && draggableFields.length > 0 && (
                                <List
                                    rowKey={(item: any) => item?.key}
                                    dataSource={draggableFields
                                        .sort((a: any, b: any) => a.position - b.position)
                                        .map((item: any) => ({
                                          key: item.id,
                                          label: item.name,
                                          typeId: item.typeId,
                                          isKey: item.isKey,
                                        }))}
                                    size="small"
                                    renderItem={(item: any, index: any) => (
                                        <Draggable
                                            draggableId={`draggable-${index}`}
                                            index={index}
                                            isDragDisabled={item.label === "Code"}
                                        >
                                          {(provided) => (
                                              <div
                                                  className={
                                                    selectedField?.id === item.key
                                                        ? "fieldMenu selectedField"
                                                        : "fieldMenu"
                                                  }
                                                  ref={provided.innerRef}
                                                  {...provided.draggableProps}
                                                  {...provided.dragHandleProps}
                                              >
                                                <List.Item>
                                                  <div
                                                      style={{
                                                        display: "flex",
                                                        gap: "10px",
                                                        alignItems: "center",
                                                        width: "100%",
                                                        textOverflow: "ellipsis",
                                                        overflowX: "hidden",
                                                      }}
                                                  >
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheckboxChange(
                                                                item.key,
                                                                e.target.checked
                                                            )
                                                        }
                                                        checked={checkedKeys.includes(
                                                            item.key.toString()
                                                        )}
                                                    />
                                                    <span style={{ flex: 1 }}>
                                                      {item?.label?.length > 25
                                                          ? item?.label?.slice(0, 25) + "..."
                                                            : item?.label}
                                                    </span>
                                                    {item?.isKey && <KeyOutlined />}
                                                  </div>
                                                </List.Item>
                                              </div>
                                          )}
                                        </Draggable>
                                    )}
                                />
                            )}
                            {provided.placeholder}
                          </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </>
            </div>
        )}
        {selectedLoadfile?.id && (
        <div className="export-config-container">
          <div className="export-header">
            <span>3. Export configuration</span>
            <div className="action-buttons">
              <Tooltip title="Save selected">
                <Button
                  className={""}
                  disabled={false}
                  onClick={() => exportLoadfile(true, false)}
                  size="small"
                  icon={<CheckOutlined />}
                  // loading={updateTableLoading}
                >
                  {t("General.Labels.Save", {
                    lngs: i18n.languages,
                    defaultValue: "Save",
                  })}
                </Button>
              </Tooltip>
              <Tooltip title="Export Loadfile">
                <Button
                  className={""}
                  disabled={false}
                  onClick={() => exportLoadfile(false, true)}
                  size="small"
                  icon={<ExportOutlined />}
                  // loading={updateTableLoading}
                >
                  {t("General.Labels.Export", {
                    lngs: i18n.languages,
                    defaultValue: "Export",
                  })}
                </Button>
              </Tooltip>
              <Tooltip title="Save & Export Loadfile">
                <Button
                    className={""}
                    disabled={false}
                    onClick={() => exportLoadfile(true, true)}
                    size="small"
                    icon={<ExportOutlined />}
                    // loading={updateTableLoading}
                >
                  {t("General.Labels.Save & Export ", {
                    lngs: i18n.languages,
                    defaultValue: "Save & Export",
                  })}
                </Button>
              </Tooltip>
            </div>
          </div>
          <Divider />
          <div>
            <Form<ExportConfiguration> form={exportConfigurationForm} layout="vertical" size="small" style={{ width: "50%" }}>
              <Form.Item
                  name="exportFormat"
                  label={t("Page.Operation.Publish.Labels.ExportFormat", {
                    lngs: i18n.languages,
                    defaultValue: "Export Format:",
                  })}
                  tooltip={t("Page.Operation.Publish.Labels.ExportFormat", {
                    lngs: i18n.languages,
                    defaultValue: "",
                  })}
              >
                <Select
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Select export format"
                    options={exportFormats}
                ></Select>
              </Form.Item>
              {isDelimiterVisible && (
                  <Form.Item
                      name="delimiter"
                      label={t("Page.Operation.Publish.Labels.Delimiter", {
                        lngs: i18n.languages,
                        defaultValue: "Set a delimiter:",
                      })}
                      tooltip={t("Page.Operation.Publish.Labels.SetDelimiter", {
                        lngs: i18n.languages,
                        defaultValue: "",
                      })}
                  >
                    <Select
                        allowClear
                        style={{ width: "100%" }}
                        placeholder="Select delimiter or enter custom"
                        options={delimiterOptions}
                    ></Select>
                  </Form.Item>    
              )}
              {isTextQualifierVisible && (
                  <Form.Item
                      name="textQualifier"
                      label={t("Page.Operation.Publish.Labels.TextQualifier", {
                        lngs: i18n.languages,
                        defaultValue: "Text Qualifier:",
                      })}
                      tooltip={t("Page.Operation.Publish.Labels.TextQualifier", {
                        lngs: i18n.languages,
                        defaultValue: "",
                      })}
                  >
                    <Select
                        allowClear
                        style={{ width: "100%" }}
                        placeholder="Select text qualifier"
                        options={textQualifierOptions}
                    ></Select>
                  </Form.Item>
              )}
              {isOtherExportFieldsVisible && (
                  <>
                    <Form.Item name="includeHeader" valuePropName="checked">
                      <Checkbox>
                        Include Header Row
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                        name="encoding"
                        label={t("Page.Operation.Publish.Labels.SelectFileEncoding", {
                          lngs: i18n.languages,
                          defaultValue: "Select File Encoding:",
                        })}
                        tooltip={t("Page.Operation.Publish.Labels.SelectFileEncoding", {
                          lngs: i18n.languages,
                          defaultValue: "",
                        })}
                    >
                      <Select
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Select file encoding"
                          options={encodingOptions}
                      ></Select>
                    </Form.Item>
                    <Form.Item
                        name="dateFormat"
                        label={t("Page.Operation.Publish.Labels.SetDateFormat", {
                          lngs: i18n.languages,
                          defaultValue: "Select Date Format:",
                        })}
                        tooltip={t("Page.Operation.Publish.Labels.SetDateFormat", {
                          lngs: i18n.languages,
                          defaultValue: "",
                        })}
                    >
                      <Select
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Select date format"
                          options={dateFormatOptions}
                      ></Select>
                    </Form.Item>
                    <Form.Item
                        name="fileName"
                        label={t("Page.Operation.Publish.Labels.NameFile", {
                          lngs: i18n.languages,
                          defaultValue: "File name:",
                        })}
                        tooltip={t("Page.Operation.Publish.Labels.NameFile", {
                          lngs: i18n.languages,
                          defaultValue: "",
                        })}
                    >
                      <Input
                          disabled={false}
                          placeholder={
                            t("General.Placeholders.EnterValue", {
                              lngs: i18n.languages,
                              defaultValue: "Enter value",
                            })!
                          }
                      />
                    </Form.Item>
                  </>
              )}
            </Form>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default Publish;
